import { orchestrator } from 'satcheljs';
import { showOfficeAppCard } from '../actions/showOfficeAppCard';
import { completeOfficeApp } from '../actions/completeOfficeApp';
import { lazymountOfficeAppCard } from 'owa-guided-setup-cards';

orchestrator(showOfficeAppCard, () => {
    lazymountOfficeAppCard.importAndExecute(completeOfficeApp);
});
